import React, { useState, useEffect } from 'react';
import axios from "axios";
import { Container, Row, Col, Form, Button, Spinner } from "react-bootstrap";
import { useLocalStorage } from "./useLocalStorage";
import config from './config.json';

const Register = ({ prevStep }) => {
  
  const [local, setLocal] = useLocalStorage("audit_energetique", {
    email: ""
  });

  let type_bien = localStorage.getItem("type_bien");
  let construction_date = localStorage.getItem("construction_date");
  let acquisition_type = localStorage.getItem("acquisition_type");
  let location = localStorage.getItem('location');
  let natural_gas_network = localStorage.getItem('natural_gas_network');
  let windows_count = localStorage.getItem("windows_count");
  let household_people = localStorage.getItem("household_people");
  let total_income = localStorage.getItem("total_income");
  
  let heating_energy = localStorage.getItem("heating_energy");
  let oil_type = localStorage.getItem('oil_type');
  let electric_type = localStorage.getItem('electric_type');
  let gas_type = localStorage.getItem('gas_type');
  let attic_insulation = localStorage.getItem('attic_insulation');
  let wall_insulation_type = localStorage.getItem('wall_insulation_type');
  let floor_insulation = localStorage.getItem('floor_insulation');
  let heat_pump = localStorage.getItem('heat_pump');
  let type_pose = localStorage.getItem('type_pose');
  let storage_heater = localStorage.getItem('storage_heater');
  let type_wood_boiler = localStorage.getItem('type_wood_boiler');
  let storage_space = localStorage.getItem('storage_space');
  let type_wood_stove = localStorage.getItem('type_wood_stove');
  
  let attics_insulation_type = localStorage.getItem('attics_insulation_type');
  let hybrid_heat_pump_type = localStorage.getItem('hybrid_heat_pump_type');
  
  let dataLocal = JSON.parse(localStorage.getItem("audit_energetique"));
  let project = localStorage.getItem("project");
  let start_work = localStorage.getItem("start_work");
  
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false); // Nouvel état pour le chargement
  const [isSubmitting, setIsSubmitting] = useState(false); // Nouvel état pour le suivi de la soumission

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLocal({ ...local, [name]: value });
  }; 

  const [work_types, setWorkTypes] = useState([]);

  useEffect(() => {
    setWorkTypes(JSON.parse(localStorage.getItem("work_types")));
  }, [work_types]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!isSubmitting) {
      setIsSubmitting(true); // Marquer le formulaire comme soumis

      let formData = new FormData();
      formData.append('type_bien', type_bien);
      formData.append('construction_date', construction_date);
      formData.append('habitable_surface', dataLocal.habitable_surface);
      formData.append('windows_count', windows_count);
      formData.append('household_people', household_people);
      formData.append('total_income', total_income);
      
      formData.append('heating_energy', heating_energy);
      formData.append('oil_type', oil_type);
      formData.append('electric_type', electric_type);
      formData.append('gas_type', gas_type);
      formData.append('attic_insulation', attic_insulation);
      formData.append('floor_insulation', floor_insulation);
      formData.append('heat_pump', heat_pump);
      formData.append('type_pose', type_pose);
      formData.append('storage_heater', storage_heater);
      formData.append('type_wood_boiler', type_wood_boiler);
      formData.append('storage_space', storage_space);
      formData.append('type_wood_stove', type_wood_stove);
       work_types.forEach((value) => {
        formData.append("work_types[]", value);
      });
      
      formData.append('attics_insulation_type', attics_insulation_type);
      formData.append('wall_insulation_type', wall_insulation_type);
      formData.append('hybrid_heat_pump_type', hybrid_heat_pump_type);
  
      formData.append('attics_insulation_surface', dataLocal.attics_insulation_surface);
      formData.append('wall_insulation_surface', dataLocal.wall_insulation_surface);
      formData.append('floor_insulation_surface', dataLocal.floor_insulation_surface);
      formData.append('terrace_insulating_surface', dataLocal.terrace_insulating_surface);
      formData.append('heat_pump_surface', dataLocal.heat_pump_surface);
      formData.append('address', dataLocal.address);
      formData.append('acquisition_type', acquisition_type);
      formData.append('code_zip', dataLocal.code_zip);
      formData.append('location', location);
      formData.append('natural_gas_network', natural_gas_network);
      
      formData.append('project', project);
      formData.append('start_work', start_work);
      
      formData.append('civility', dataLocal.civility);
      formData.append('firstname', dataLocal.firstname);
      formData.append('lastname', dataLocal.lastname);
      formData.append('phone', dataLocal.phone);
      formData.append('email', local.email);
     
        setLoading(true);

        axios({
          method: "POST",
		      url: config.register,
          data: formData
        })
          .then((response) => {
            setLoading(false);

            if (response.data.message) {
              console.log(response.data.message);
              setSuccess(response.data.message);
              setFormSubmitted(true);
              localStorage.clear();
            }  
            else if (response.data.error) {
              console.log(response.data.error);
              setError(response.data.error);
            }

            setIsSubmitting(false); // Réinitialiser l'état de soumission
          })
        } 
        else {
          setIsSubmitting(false); // Réinitialiser l'état de soumission si les mots de passe ne correspondent pas
        }
    };  

  return (
    <Container>
      <Form onSubmit={handleSubmit}>
        <h3 className="text-center">Dernière étape</h3>

        {success && (
          <div className="alert alert-success text-center mt-3">{success}</div>
        )}

        {!success && error && (
          <div className="alert alert-danger text-center">{error}</div>
        )}

        {!formSubmitted && (
          <>
            <div className="col-lg-6 offset-lg-3 mt-3">
              <div className="mb-3"> 
                <label>Email</label><br />
                <input type="email" name="email" value={local.email} className="form-control" onChange={handleChange} required/>
              </div> 
            </div>

            <Row className="mt-3 d-flex align-items-center justify-content-center">
              <Col>
                <Button type="button" variant="secondary" onClick={prevStep} disabled={isSubmitting}>
                  Précédent
                </Button>
                <Button
                  type="submit"
                  name="submit"
                  variant="primary"
                  className="ms-3"
                  disabled={!local.email || isSubmitting}
                >
                  {loading ? (
                    <>
                      <Spinner animation="border" size="sm" role="status" />
                      <span className="visually-hidden">Chargement...</span>
                    </>
                  ) : (
                    "Valider"
                  )}
                </Button>
              </Col>
            </Row>
          </>
        )}
      </Form>
    </Container>
  );
}

export default Register;